const bookappointments = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        class: "px-4",
        title: "Book Appointments",
      },
      {
        type: "tabs",
        size: "12",
        class: "px-4 pt-4",
        children: [
          {
            title: "Settings",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  class: "pl-4 pt-3",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  form: {
                    info_box: {
                      type: "toggle",
                      label: "Info Box",
                      hideLabel: false,
                      size: "12",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      style: "",
                    },
                    info_title: {
                      type: "text",
                      label: "Title",
                      placeholder: "Enter the title",
                      required: true,
                      displayOn: "info_box",
                      displayOnValue: "true",
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    info_description: {
                      type: "ckeditor",
                      label: "Info Box Page Description",
                      placeholder: "Enter Description",
                      displayOn: "info_box",
                      displayOnValue: "true",
                      required: true,
                      size: "12",
                      class: "editor-toolbar-bg-change",
                    },
                    hr0: {
                      type: "hr",
                      size: "12",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Settings Description",
                      placeholder: "Enter Description",
                      required: true,
                      size: "12",
                      class: "editor-toolbar-bg-change",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "categoryTypes",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: true,
              deleteButton: false,
              addNewSuccessTitle: "Type Added!",
              addNewSuccessMessage: "Type Added Successfully!",
              addNewErrorTitle: "Type Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Type Deleted!",
              deleteSuccessMessage: "Type Deleted Successfully!",
              deleteErrorTitle: "Type Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Type Activated!",
              activeSuccessMessage: "Type Activated Successfully!",
              activeErrorTitle: "Type Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Type Updated!",
              updateSuccessMessage: "Type Updated Successfully!",
              updateErrorTitle: "Type Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Type",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Type",
                    placeholder: "Enter Type",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  nhs_app: true,
                  patient_access: true,
                  systm_online: true,
                  contact_us: true,
                  description: "",
                  tile_description: "",
                  optional_toggled: false,
                  when_to_visit_utc: "",
                  when_to_go_ae: "",
                },
              },
            },
            children: [
              {
                type: "optionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Types",
                  type: "typeList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    layout_1: {
                      description: {
                        type: "ckeditor",
                        label: "Description ",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      pharmacy_first_toggle: {
                        type: "toggle",
                        label: "Pharmacy First",
                        size: "12",
                        required: false,
                      },
                      formSection: {
                        components: {
                          pharmacy_first_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "pharmacy_first_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          pharmacy_first_description: {
                            type: "ckeditor",
                            label: "Pharmacy First Description",
                            placeholder: "Enter Description",
                            displayOn: "pharmacy_first_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          pharmacy_cta_section: {
                            type: "toggle",
                            label: "Call to Action",
                            displayOn: "pharmacy_first_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          pharmacy_cta_label: {
                            type: "text",
                            label: "Label",
                            placeholder: "Find a Pharmacy",
                            required: true,
                            info: true,
                            character_count: 100,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "pharmacy_cta_section",
                            displayOnValue: "true",
                          },
                          pharmacy_cta_link: {
                            type: "text",
                            label: "Link",
                            placeholder: "Enter URL",
                            required: true,
                            info: true,
                            character_count: 1000,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "pharmacy_cta_section",
                            displayOnValue: "true",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "pharmacy_first_toggle",
                        displayOnValue: "true",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      online_consultation_toggle: {
                        type: "toggle",
                        label: "Online Consultation",
                        size: "12",
                        required: false,
                      },
                      type: {
                        type: "select",
                        label: "Type",
                        placeholder: "Select type",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                        options: [
                          "Accurx",
                          "Anima",
                          "EConsult",
                          "Klinik",
                          "Patchs",
                          "Rapid Health",
                          "System Connect",
                        ],
                      },
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter the title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      online_consultation_description: {
                        type: "ckeditor",
                        label: "Online Consultation Description",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                        class: "editor-toolbar-bg-change",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      title_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        required: true,
                        info: true,
                        character_count: 1000,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                      gp_online_service_toggle: {
                        type: "toggle",
                        label: "GP Online Services",
                        size: "12",
                        required: false,
                      },
                      formSection2: {
                        components: {
                          gp_online_service_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          gp_online_service_description: {
                            type: "ckeditor",
                            label: "GP Online Services Description",
                            placeholder: "Enter Description",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          nhs_app: {
                            type: "toggle",
                            label: "NHS App",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          patient_access: {
                            type: "toggle",
                            label: "Patient Access",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          systm_online: {
                            type: "toggle",
                            label: "System Online",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "gp_online_service_toggle",
                        displayOnValue: "true",
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      call_the_practice_toggle: {
                        type: "toggle",
                        label: "Call the practice",
                        size: "12",
                        required: false,
                      },
                      formSection3: {
                        components: {
                          call_the_practice_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          call_the_practice_description: {
                            type: "ckeditor",
                            label: "Call the Practice Description",
                            placeholder: "Enter Description",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          call_the_practice_section: {
                            type: "toggle",
                            label: "Call to Action ",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          phone_number: {
                            type: "text",
                            label: "Phone Number",
                            placeholder: "Phone Number",
                            displayOn: "call_the_practice_section",
                            displayOnValue: "true",
                            required: false,
                            info: false,
                            character_count: 15,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_toggle: {
                        type: "toggle",
                        label: "Info",
                        size: "12",
                        required: false,
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_description: {
                        type: "ckeditor",
                        label: "Info Description",
                        placeholder: "Description",
                        displayOn: "info_toggle",
                        displayOnValue: "true",
                        displayOn2: "call_the_practice_toggle",
                        displayOnValue2: "true",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                      additional_tile_toggle: {
                        type: "toggle",
                        label: "Additional tile",
                        size: "12",
                        required: false,
                      },
                      formSection4: {
                        components: {
                          additional_tile_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Additional tile",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          additional_tile_description: {
                            type: "ckeditor",
                            label: "Additional Tile Description",
                            placeholder: "Enter Description",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          additional_tile_section: {
                            type: "toggle",
                            label: "Call to Action  ",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          additional_tile_label: {
                            type: "text",
                            label: "Label",
                            placeholder: "Find a Pharmacy",
                            required: true,
                            info: true,
                            character_count: 100,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                          additional_tile_link: {
                            type: "text",
                            label: "Link",
                            placeholder: "Enter URL",
                            required: true,
                            info: true,
                            character_count: 1000,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "additional_tile_toggle",
                        displayOnValue: "true",
                      },
                    },
                    layout_2: {
                      description: {
                        type: "ckeditor",
                        label: "Description ",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr3: {
                        type: "hr",
                        size: "12",
                      },
                      online_consultation_toggle: {
                        type: "toggle",
                        label: "Online Consultation",
                        size: "12",
                        required: false,
                      },
                      type: {
                        type: "select",
                        label: "Type",
                        placeholder: "Select type",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                        options: [
                          "Accurx",
                          "Anima",
                          "EConsult",
                          "Klinik",
                          "Patchs",
                          "Rapid Health",
                          "System Connect",
                        ],
                      },
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter the title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      online_consultation_description: {
                        type: "ckeditor",
                        label: "Online Consultation Description",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                        class: "editor-toolbar-bg-change",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      title_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        required: true,
                        info: true,
                        character_count: 1000,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                      gp_online_service_toggle: {
                        type: "toggle",
                        label: "GP Online Services",
                        size: "12",
                        required: false,
                      },
                      formSection2: {
                        components: {
                          gp_online_service_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          gp_online_service_description: {
                            type: "ckeditor",
                            label: "GP Online Services Description",
                            placeholder: "Enter Description",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          nhs_app: {
                            type: "toggle",
                            label: "NHS App",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          patient_access: {
                            type: "toggle",
                            label: "Patient Access",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          systm_online: {
                            type: "toggle",
                            label: "System Online",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "gp_online_service_toggle",
                        displayOnValue: "true",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      call_the_practice_toggle: {
                        type: "toggle",
                        label: "Call the Practice",
                        size: "12",
                        required: false,
                      },
                      formSection3: {
                        components: {
                          call_the_practice_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          call_the_practice_description: {
                            type: "ckeditor",
                            label: "Call the Practice Description",
                            placeholder: "Enter Description",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          call_the_practice_section: {
                            type: "toggle",
                            label: "Call to Action  ",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          phone_number: {
                            type: "text",
                            label: "Phone Number",
                            placeholder: "Phone Number",
                            displayOn: "call_the_practice_section",
                            displayOnValue: "true",
                            required: false,
                            info: false,
                            character_count: 15,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_toggle: {
                        type: "toggle",
                        label: "Info",
                        size: "12",
                        required: false,
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_description: {
                        type: "ckeditor",
                        label: "Info Description",
                        placeholder: "Description",
                        displayOn: "info_toggle",
                        displayOnValue: "true",
                        displayOn2: "call_the_practice_toggle",
                        displayOnValue2: "true",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                      additional_tile_toggle: {
                        type: "toggle",
                        label: "Additional tile",
                        size: "12",
                        required: false,
                      },
                      formSection4: {
                        components: {
                          additional_tile_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Additional tile",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          additional_tile_description: {
                            type: "ckeditor",
                            label: "Additional Tile Description",
                            placeholder: "Enter Description",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          additional_tile_section: {
                            type: "toggle",
                            label: "Call to Action  ",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          additional_tile_label: {
                            type: "text",
                            label: "Label",
                            placeholder: "Find a Pharmacy",
                            required: true,
                            info: true,
                            character_count: 100,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                          additional_tile_link: {
                            type: "text",
                            label: "Link",
                            placeholder: "Enter URL",
                            required: true,
                            info: true,
                            character_count: 1000,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "additional_tile_toggle",
                        displayOnValue: "true",
                      },
                    },
                    layout_3: {
                      description: {
                        type: "ckeditor",
                        label: "Description  ",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      call_the_practice_toggle: {
                        type: "toggle",
                        label: "Call the practice",
                        size: "12",
                        required: false,
                      },
                      formSection3: {
                        components: {
                          call_the_practice_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          call_the_practice_description: {
                            type: "ckeditor",
                            label: "Call the Practice Description",
                            placeholder: "Enter Description",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          call_the_practice_section: {
                            type: "toggle",
                            label: "Call to Action       ",
                            displayOn: "call_the_practice_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          phone_number: {
                            type: "text",
                            label: "Phone Number",
                            placeholder: "Phone Number",
                            displayOn: "call_the_practice_section",
                            displayOnValue: "true",
                            required: false,
                            info: false,
                            character_count: 15,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_toggle: {
                        type: "toggle",
                        label: "Info",
                        size: "12",
                        required: false,
                        displayOn: "call_the_practice_toggle",
                        displayOnValue: "true",
                      },
                      info_description: {
                        type: "ckeditor",
                        label: "Info Description",
                        placeholder: "Description",
                        displayOn: "info_toggle",
                        displayOnValue: "true",
                        displayOn2: "call_the_practice_toggle",
                        displayOnValue2: "true",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      online_consultation_toggle: {
                        type: "toggle",
                        label: "Online Consultation",
                        size: "12",
                        required: false,
                      },
                      type: {
                        type: "select",
                        label: "Type",
                        placeholder: "Select type",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                        options: [
                          "Accurx",
                          "Anima",
                          "EConsult",
                          "Klinik",
                          "Patchs",
                          "Rapid Health",
                          "System Connect",
                        ],
                      },
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter the title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      online_consultation_description: {
                        type: "ckeditor",
                        label: "Online Consultation Description",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                        class: "editor-toolbar-bg-change",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      title_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        required: true,
                        info: true,
                        character_count: 1000,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                      gp_online_service_toggle: {
                        type: "toggle",
                        label: "GP Online Services",
                        size: "12",
                        required: false,
                      },
                      formSection2: {
                        components: {
                          gp_online_service_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Pharmacy First",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          gp_online_service_description: {
                            type: "ckeditor",
                            label: "GP Online Services Description",
                            placeholder: "Enter Description",
                            displayOn: "gp_online_service_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          nhs_app: {
                            type: "toggle",
                            label: "NHS App",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          patient_access: {
                            type: "toggle",
                            label: "Patient Access",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                          systm_online: {
                            type: "toggle",
                            label: "System Online",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "3",
                            style: "",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "gp_online_service_toggle",
                        displayOnValue: "true",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                      additional_tile_toggle: {
                        type: "toggle",
                        label: "Additional tile",
                        size: "12",
                        required: false,
                      },
                      formSection4: {
                        components: {
                          additional_tile_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Additional tile",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          additional_tile_description: {
                            type: "ckeditor",
                            label: "Additional Tile Description",
                            placeholder: "Enter Description",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          additional_tile_section: {
                            type: "toggle",
                            label: "Call to Action        ",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          additional_tile_label: {
                            type: "text",
                            label: "Label",
                            placeholder: "Find a Pharmacy",
                            required: true,
                            info: true,
                            character_count: 100,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                          additional_tile_link: {
                            type: "text",
                            label: "Link",
                            placeholder: "Enter URL",
                            required: true,
                            info: true,
                            character_count: 1000,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "additional_tile_toggle",
                        displayOnValue: "true",
                      },
                    },
                    layout_4: {
                      description: {
                        type: "ckeditor",
                        label: "Description   ",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      hr4: {
                        type: "hr",
                        size: "12",
                      },
                      when_to_close_toggle: {
                        type: "toggle",
                        label: "Where to go",
                        size: "12",
                        required: false,
                      },
                      when_to_go_selector: {
                        type: "radio",
                        label: "",
                        size: "12",
                        required: false,
                        default: "999_test",
                        options: ["999 test", "When to visit UTC"],
                        displayOn: "when_to_close_toggle",
                        displayOnValue: "true",
                      },
                      hr0: {
                        type: "hr",
                        size: "12",
                      },
                      online_consultation_toggle: {
                        type: "toggle",
                        label: "Online Consultation",
                        size: "12",
                        required: false,
                      },
                      type: {
                        type: "select",
                        label: "Type",
                        placeholder: "Select type",
                        required: false,
                        info: false,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                        options: [
                          "Accurx",
                          "Anima",
                          "EConsult",
                          "Klinik",
                          "Patchs",
                          "Rapid Health",
                          "System Connect",
                        ],
                      },
                      title: {
                        type: "text",
                        label: "Title",
                        placeholder: "Enter the title",
                        required: true,
                        info: true,
                        character_count: 250,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      online_consultation_description: {
                        type: "ckeditor",
                        label: "Online Consultation Description",
                        placeholder: "Enter Description",
                        required: true,
                        character_count: 2000,
                        size: "12",
                        class: "editor-toolbar-bg-change",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      title_link: {
                        type: "text",
                        label: "Link",
                        placeholder: "Enter Link",
                        required: true,
                        info: true,
                        character_count: 1000,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                        displayOn: "online_consultation_toggle",
                        displayOnValue: "true",
                      },
                      hr1: {
                        type: "hr",
                        size: "12",
                      },
                      nhs_111_toggle: {
                        type: "toggle",
                        label: "NHS 111",
                        size: "12",
                        required: false,
                      },
                      formSection2: {
                        components: {
                          nhs_111_description: {
                            type: "ckeditor",
                            label: "NHS 111 Description",
                            placeholder: "Description",
                            displayOn: "nhs_111_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          hr1: {
                            type: "hr",
                            size: "12",
                          },
                          nhs_111_info_toggle: {
                            type: "toggle",
                            label: "Info",
                            size: "12",
                            required: false,
                          },
                          nhs_111_info_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "NHS info title",
                            displayOn: "nhs_111_info_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          nhs_111_info_description: {
                            type: "ckeditor",
                            label: "NHS 111 Info Description",
                            placeholder: "Description",
                            displayOn: "nhs_111_info_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "nhs_111_toggle",
                        displayOnValue: "true",
                      },
                      nhs_111_info_link_toggle: {
                        type: "toggle",
                        label: "Call to action             ",
                        displayOn: "nhs_111_toggle",
                        displayOnValue: "true",
                        size: "12",
                        required: false,
                      },
                      nhs_external_links: {
                        type: "textinputs",
                        label: "External Links ",
                        placeholder: "Enter Link",
                        displayOn: "nhs_111_info_link_toggle",
                        displayOnValue: "true",
                        displayOn2: "nhs_111_toggle",
                        displayOnValue2: "true",
                        required: false,
                        info: false,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        limit: 1,
                      },
                      call_the_practice_section: {
                        type: "toggle",
                        label: "Call to Action                 ",
                        displayOn: "nhs_111_info_link_toggle",
                        displayOnValue: "true",
                        displayOn2: "nhs_111_toggle",
                        displayOnValue2: "true",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      phone_number: {
                        type: "text",
                        label: "Phone Number",
                        placeholder: "Phone Number",
                        displayOn: "call_the_practice_section",
                        displayOnValue: "true",
                        displayOn2: "nhs_111_toggle",
                        displayOnValue2: "true",
                        required: false,
                        info: false,
                        character_count: 15,
                        disabled: false,
                        class: "",
                        size: "6",
                        style: "",
                      },
                      hr2: {
                        type: "hr",
                        size: "12",
                      },
                      urgent_treatment_center_toggle: {
                        type: "toggle",
                        label: "Urgent Treatment Centre",
                        size: "12",
                        required: false,
                      },
                      urgent_treatment_center_description: {
                        type: "ckeditor",
                        label: "Urgent Treatment Centre Description",
                        placeholder: "Enter Description",
                        displayOn: "urgent_treatment_center_toggle",
                        displayOnValue: "true",
                        required: true,
                        character_count: 2000,
                        size: "12",
                      },
                      urgent_treatmen_cta_section: {
                        type: "toggle",
                        label: "Call to Action                         ",
                        displayOn: "urgent_treatment_center_toggle",
                        displayOnValue: "true",
                        placeholder: "",
                        required: false,
                        info: true,
                        character_count: 0,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                      },
                      urgent_treatment_external_links: {
                        type: "textinputs",
                        label: "External Links",
                        placeholder: "Enter Link",
                        displayOn: "urgent_treatmen_cta_section",
                        displayOnValue: "true",
                        displayOn2: "urgent_treatment_center_toggle",
                        displayOnValue2: "true",
                        required: false,
                        info: false,
                        disabled: false,
                        class: "",
                        size: "12",
                        style: "",
                        limit: 1,
                      },
                      hr5: {
                        type: "hr",
                        size: "12",
                      },
                      additional_tile_toggle: {
                        type: "toggle",
                        label: "Additional tile",
                        size: "12",
                        required: false,
                      },
                      formSection4: {
                        components: {
                          additional_tile_title: {
                            type: "text",
                            label: "Title",
                            placeholder: "Additional tile",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 250,
                            size: "12",
                          },
                          additional_tile_description: {
                            type: "ckeditor",
                            label: "Additional Tile Description",
                            placeholder: "Enter Description",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            required: true,
                            character_count: 2000,
                            size: "12",
                          },
                          additional_tile_section: {
                            type: "toggle",
                            label:
                              "Call to Action                                ",
                            displayOn: "additional_tile_toggle",
                            displayOnValue: "true",
                            placeholder: "",
                            required: false,
                            info: true,
                            character_count: 0,
                            disabled: false,
                            class: "",
                            size: "12",
                            style: "",
                          },
                          additional_tile_label: {
                            type: "text",
                            label: "Label",
                            placeholder: "Find a Pharmacy",
                            required: true,
                            info: true,
                            character_count: 100,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                          additional_tile_link: {
                            type: "text",
                            label: "Link",
                            placeholder: "Enter URL",
                            required: true,
                            info: true,
                            character_count: 1000,
                            disabled: false,
                            class: "",
                            size: "6",
                            style: "",
                            displayOn: "additional_tile_section",
                            displayOnValue: "true",
                          },
                        },
                        class: "",
                        size: "12",
                        style: "",
                        type: "formSection",
                        displayOn: "additional_tile_toggle",
                        displayOnValue: "true",
                      },
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "FAQ",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New FAQ",
                type: "page",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  answer: "",
                },
              },
            },
            children: [
              {
                type: "patientGroupTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "list",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "FAQ Form",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  form: {
                    title: {
                      type: "text",
                      label: "Question",
                      placeholder: "Enter Question",
                      required: true,
                      info: false,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    answer: {
                      type: "ckeditor",
                      label: "Answer",
                      placeholder: "Enter Answer",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { bookappointments };
